var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduledStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33594 18.5C11.4577 18.5 13.4925 17.6571 14.9928 16.1569C16.4931 14.6566 17.3359 12.6217 17.3359 10.5C17.3359 8.37827 16.4931 6.34344 14.9928 4.84315C13.4925 3.34285 11.4577 2.5 9.33594 2.5C7.21421 2.5 5.17937 3.34285 3.67908 4.84315C2.17879 6.34344 1.33594 8.37827 1.33594 10.5C1.33594 12.6217 2.17879 14.6566 3.67908 16.1569C5.17937 17.6571 7.21421 18.5 9.33594 18.5ZM10.3359 6.5C10.3359 6.23478 10.2306 5.98043 10.043 5.79289C9.85551 5.60536 9.60115 5.5 9.33594 5.5C9.07072 5.5 8.81637 5.60536 8.62883 5.79289C8.44129 5.98043 8.33594 6.23478 8.33594 6.5V10.5C8.33599 10.7652 8.44139 11.0195 8.62894 11.207L11.4569 14.036C11.5498 14.1289 11.6601 14.2026 11.7815 14.2529C11.9029 14.3032 12.033 14.3291 12.1644 14.3291C12.2958 14.3291 12.4259 14.3032 12.5473 14.2529C12.6687 14.2026 12.779 14.1289 12.8719 14.036C12.9648 13.9431 13.0385 13.8328 13.0888 13.7114C13.1391 13.59 13.165 13.4599 13.165 13.3285C13.165 13.1971 13.1391 13.067 13.0888 12.9456C13.0385 12.8242 12.9648 12.7139 12.8719 12.621L10.3359 10.086V6.5Z",
    fill: "#FB8C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledStatusIcon);
export default __webpack_public_path__ + "static/media/scheduled_status_icon.759fd929e235bdb07b388423157c27e2.svg";
export { ForwardRef as ReactComponent };